/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentIntentStatus;

(function (PaymentIntentStatus) {
  PaymentIntentStatus["PENDING"] = "pending";
  PaymentIntentStatus["SUCCEEDED"] = "succeeded";
  PaymentIntentStatus["PAYMENT_ERROR"] = "payment_error";
  PaymentIntentStatus["FAILED"] = "failed";
  PaymentIntentStatus["CANCELED"] = "canceled";
  PaymentIntentStatus["COMPLETED"] = "completed";
  PaymentIntentStatus["DECLINED"] = "declined";
  PaymentIntentStatus["UNKNOWN"] = "unknown";
})(PaymentIntentStatus || (PaymentIntentStatus = {}));